import { render, staticRenderFns } from "./grossing-touch-sample-view-header.vue?vue&type=template&id=fddffb8e&"
import script from "./grossing-touch-sample-view-header.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-sample-view-header.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-sample-view-header.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports